import { parseUnits } from 'viem';
/** The same transaction payload is used when quoting gas and requesting a wallet transfer. */
export const resolveEVMTransactionRequest = ({ amount, amountInBaseUnits, callData, depositAddress, network, token, account, }) => ({
    chainId: Number(network.chain_id),
    to: depositAddress,
    value: token.contract ? 0n : amountInBaseUnits != null
        ? BigInt(amountInBaseUnits)
        : parseUnits(amount.toString(), token.decimals),
    data: (callData || '0x'),
    account,
});
